import {
  ProvinceSelectField,
  CitySelectField,
  DistrictSelectField,
  SubDistrictSelectField,
  InputField
} from 'components'
import { TitlePage } from 'components/atoms'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag           : PropTypes.object.isRequired,
  handleAddressChange : PropTypes.func.isRequired
}

const AddressFields = ({
  formikBag,
  handleAddressChange
}) => {
  const getProvinceValue = (formikBag, provinceKey) => {
    const keys                     = provinceKey.split('.')
    const { values: formikValues } = formikBag
    let newValues                  = formikValues

    keys.map((k) => {
      if (newValues == null) return
      newValues = newValues[ k ]
    })
    return newValues
  }

  return (
    <>
      <TitlePage mainTitle={ 'User Address' } />
      <InputField
        type='text'
        name='user_address.street_address'
        label='Jalan'
        required={ true }
      />
      <ProvinceSelectField
        label='Provinsi'
        required={ true }
        name='user_address.tl_province_id'
        onChange={ (event) => {
          handleAddressChange(
            formikBag,
            'user_address.tl_province_id',
            'provinsi',
            event
          )
        } }
      />
      <CitySelectField
        name='user_address.tl_city_id'
        label='Kota'
        required={ true }
        provinceValue={ getProvinceValue(formikBag,'user_address.tl_province_id') }
        onChange={ (event) => {
          handleAddressChange(
            formikBag,
            'user_address.tl_city_id',
            'kota',
            event
          )
        } }
      />
      <DistrictSelectField
        name='user_address.tl_district_id'
        label='Kecamatan'
        required={ true }
        formikBag={ formikBag }
        provinceKey='user_address.tl_province_id'
        cityKey='user_address.tl_city_id'
        onChange={ (event) => {
          handleAddressChange(
            formikBag,
            'user_address.tl_district_id',
            'kecamatan',
            event
          )
        } }
      />
      <SubDistrictSelectField
        name='user_address.tl_sub_district_id'
        label='Kelurahan'
        required={ true }
        formikBag={ formikBag }
        provinceKey='user_address.tl_province_id'
        cityKey='user_address.tl_city_id'
        districtKey='user_address.tl_district_id'
        postalCodeKey='user_address.postal_code'
        onChangeCallback={ (event) => {
          handleAddressChange(
            formikBag,
            'user_address.tl_sub_district_id',
            'kelurahan',
            event
          )
        } }
      />
      <InputField
        type='text'
        name='user_address.postal_code'
        label='Kode Pos'
        required={ true }
      />
    </>
  )
}
AddressFields.propTypes = propTypes

export default AddressFields